import React from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import HeadingRenderer from "~components/markdown/renderers/heading";

type PropTypes = {
    children: string;
}

function MarkdownReader({ children }: PropTypes) {
    const components = {
        heading: HeadingRenderer,
    };
    return (
        <ReactMarkdown renderers={components} plugins={[gfm]}>
            {children}
        </ReactMarkdown>
    );
}

export default MarkdownReader;


